import React from 'react';
import { dateFns } from '../../helpers';

export function WidgetDateTime ({ date, format = 'dd/MM/yyyy HH:mm' }) {
    const parsedDate = new Date(date);
    return (<span>{date && dateFns.format(parsedDate, format)}</span>);
}

// Set display names for debugging.
if (process.env.NODE_ENV !== 'production') {
    WidgetDateTime.displayName = 'WidgetDateTime';
}
